import { useContext } from 'react'
import { KeycloakService } from '@nv/auth'
import { KeycloakAdminService } from '@nv/auth'
import { NVButton } from '@nv/basic-components'
import { LoginFlowContext } from '@nv/contexts'
import { useCurrentTime } from '@nv/hooks'
import { AdminVoterAuthService } from '@nv/services'
import { VoterAuthService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import WelcomeMessage from '../../../topbar/components/welcome_message/WelcomeMessage'
import styles from './SideBarFooter.module.scss'

export const SideBarFooter = ({ showCurrentTime = true }) => {
  const navigate = useNavigate()
  const currentTime = useCurrentTime()
  const LOGIN_CONTEXT = useContext(LoginFlowContext)
  const { t } = useTranslation()

  return (
    <>
      <div className={styles['container']}>
        <div>
          <WelcomeMessage />
        </div>
        {showCurrentTime && (
          <span className={styles['time']}>
            <span>{t('main.currentTime')}</span>
            <span> {currentTime}</span>
          </span>
        )}

        <NVButton
          height={50}
          width='100%'
          onClick={async () => {
            try {
              if (KeycloakService.isLoggedIn()) {
                LOGIN_CONTEXT.setLoginFlow('Login')
                await VoterAuthService.logOut(navigate)
              }
              if (KeycloakAdminService.isLoggedIn()) {
                LOGIN_CONTEXT.setLoginFlow('Admin Login')
                await AdminVoterAuthService.logOut(navigate)
              }
            } catch (error) {
              //console.log(error)
            }
          }}
          text={t('main.logout')}
          classes={{ container: styles['button'] }}
        />
      </div>
    </>
  )
}
